const allaccpayableagingdetail = { data: [], loading: true };
export const GetAllAccPayableAgingDetailTransaction = (
  state = allaccpayableagingdetail,
  action,
) => {
  switch (action.type) {
    case "get_allaccpayableagingdetailtransaction":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
